import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';
import {
  ExcelTypes,
  GetOutBoxMessagesByResellerIdDto,
  OutBoxMessagesByResellerIdDto,
} from './../../../../core/api/models';

@Component({
    selector: 'app-resellers-outbox-messages',
    templateUrl: './resellers-outbox-messages.component.html',
    standalone: false
})
export class ResellersOutboxMessagesComponent
  extends BasePageComponent
  implements OnInit
{
  //#region properties

  pageName = 'outboxMessages';
  @Input('modelWithPagination')
  modelWithPagination$: Observable<GetOutBoxMessagesByResellerIdDto>;
  @Input('items') items$: Observable<Array<OutBoxMessagesByResellerIdDto>>;
  getTableDataApiMethodName: string =
    'outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination';
  pageTitle: string = 'pages.outboxMessages.resellersTitle';
  excelType = ExcelTypes.ResellerOutboxMessages;

  //#endregion

  ngOnInit(): void {}
}
